export const TABS_REMOVE_TAB_GROUP = 'TABS_REMOVE_TAB_GROUP'
export const TABS_SET_ACTIVE_TAB = 'TABS_SET_ACTIVE_TAB'
export const SET_PENDING_TAB = 'SET_PENDING_TAB'
